import { defineComponent, h, onMounted, ref } from "vue";
import { useRepositories } from "@/infra/api/injects";
import { LocalizationError } from "@/error/error";
import { CommunicationState } from "@/type";
import { SignInInfoArgs } from "@/entities/sign_in";
import { useRouter } from "vue-router";
const SignIn = (WrappedComponent: any) =>
  defineComponent({
    name: "SignInContainer",
    setup() {
      const error = ref<LocalizationError | null>(null);
      const communicationState = ref<CommunicationState>(1);
      const repositories = useRepositories();
      const router = useRouter();
      onMounted(async () => {
        try {
          await repositories.value.SessionRepository.getAuthInfo();
          router.push({ name: "TopScreen" });
        } catch (e) {}
      });

      async function signInWithPhoneNumber(req: SignInInfoArgs): Promise<void> {
        try {
          communicationState.value = 2;
          const auth = await repositories.value.FanRepository.signInWithPhoneNumber(req);
          await repositories.value.SessionRepository.saveAuthInfo(auth);

          // リロードしてheaderの情報を更新する
          location.reload();
        } catch (e) {
          if (e instanceof LocalizationError) {
            error.value = e;
          }
        } finally {
          communicationState.value = 1;
        }
      }

      async function signInWithEmail(req: SignInInfoArgs): Promise<void> {
        try {
          communicationState.value = 2;
          const auth = await repositories.value.FanRepository.signInWithEmail(req);
          await repositories.value.SessionRepository.saveAuthInfo(auth);

          // リロードしてheaderの情報を更新する
          location.reload();
        } catch (e) {
          if (e instanceof LocalizationError) {
            error.value = e;
          }
        } finally {
          communicationState.value = 1;
        }
      }

      return {
        signInWithPhoneNumber,
        signInWithEmail,
        error,
        communicationState,
      };
    },
    render() {
      return h(WrappedComponent, {
        communicationState: this.communicationState,
        localizationError: this.error,
        onSignInWithPhoneNumber: (request: SignInInfoArgs) => this.signInWithPhoneNumber(request),
        onSignInWithEmail: (request: SignInInfoArgs) => this.signInWithEmail(request),
      });
    },
  });
export default SignIn;
